<div class="app-toast-host" aria-live="polite" aria-atomic="false">
  @for (toast of toasts$ | async; track trackByToastId($index, toast)) {
    <div
      class="app-toast"
      [ngClass]="['app-toast--' + toast.type, 'is-' + motionFor(toast.id).phase]"
      [style.--toast-drag-x.px]="motionFor(toast.id).offsetX"
      [style.--toast-drag-y.px]="motionFor(toast.id).offsetY"
      (pointerdown)="startDrag($event, toast)"
      (pointermove)="moveDrag($event)"
      (pointerup)="finishDrag($event, toast)"
      (pointercancel)="cancelDrag($event, toast)">
      @if (toast.icon) {
        <mat-icon class="app-toast__icon">{{toast.icon}}</mat-icon>
      } @else if (toast.type === 'success') {
        <mat-icon class="app-toast__icon">check_circle</mat-icon>
      }
      @else if (toast.type === 'error') {
        <mat-icon class="app-toast__icon">error_outline</mat-icon>
      }
      @else if (toast.type === 'info') {
        <mat-icon class="app-toast__icon">info</mat-icon>
      }
      @else if (toast.type === 'system') {
        <mat-icon class="app-toast__icon">notifications_active</mat-icon>
      }
      <span class="app-toast__text">@if (toast.title) {
        <strong>{{toast.title}}</strong>
      }@if (!toast.title || !sameText(toast.title, toast.message)) {{{ toast.message }}}</span>
      @if (toast.repeatCount > 1) {
        <span class="app-toast__repeat">x{{ toast.repeatCount }}</span>
      }
      @if (toast.action; as action) {
        <button
          type="button"
          class="app-toast__action"
          (pointerdown)="$event.stopPropagation()"
          (click)="executeAction($event, toast)">
          {{action.label}}
        </button>
      }
      <button
        type="button"
        class="app-toast__close"
        aria-label="Cerrar notificacion"
        (pointerdown)="$event.stopPropagation()"
        (click)="dismiss(toast)">
        <mat-icon>close</mat-icon>
      </button>
      <span class="app-toast__progress" [style.animation-duration.ms]="toast.durationMs"></span>
    </div>
  }
</div>
